<template>
  <div class="tc-modes">
    <r-text type="caption" style="margin-bottom: 4px;">
      Выбор режима
    </r-text>
    <div class="tc-modes__buttons">
      <r-radio-group
        :button-list="modes"
        :active="mode"
        @change="toggleTrafficCountsMode"
      />
    </div>
    <div class="tc-modes__multi" v-if="state.mode === 'create'">
      <div class="tc-modes__multi-switcher">
        <el-switch
          class="r-switch dark"
          v-model="state.multi"
          @change="toggleMulti"
        />
        <r-text type="caption">
          Мультисоздание
        </r-text>
      </div>
      <div class="tc-modes__multi-control" v-if="state.multiFeatures.length">
        <el-button
          size="mini"
          class="r-button icon-button tc-modes__multi-cancel"
          type="danger"
          circle
          @click="cancelMultiCreating"
        >
          <r-icon name="trash" :size="20" />
        </el-button>
        <el-button
          class="r-button tc-modes__multi-save"
          size="mini"
          type="success"
          @click="createMultiFeatures"
        >
          Сохранить объекты ({{ state.multiFeatures.length }})
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
const modes = [
  { id: "create", label: "Создание" },
  { id: "edit", label: "Редактирование" }
];

export default {
  props: ["state", "draw", "map"],
  data() {
    return {
      modes
    };
  },
  computed: {
    mode() {
      return this.state.mode;
    }
  },
  methods: {
    toggleTrafficCountsMode(mode) {
      this.$emit("toggle-mode", mode);
    },
    toggleMulti(value) {
      if (!value) {
        this.cancelMultiCreating();
      }
    },
    cancelMultiCreating() {
      this.state.multiFeatures.forEach(feature => {
        this.draw.delete(feature.id);
      });
      this.draw.changeMode("draw_general_count_points", {
        featureIds: []
      });
      this.$set(this.state, "multiFeatures", []);
    },
    createMultiFeatures() {
      this.$emit("open-gcp-card");
    }
  }
};
</script>

<style lang="scss">
.tc-modes {
  &__buttons {
    display: flex;
  }

  &__multi {
    margin-top: 16px;

    &-switcher {
      display: flex;
      align-items: center;

      .r-switch {
        margin-right: 8px;
      }
    }

    &-control {
      display: flex;
      margin-top: 8px;

      .r-button {
        width: 100%;
      }
    }

    &-cancel {
      width: auto !important;
      padding: 7px !important;
    }

    &-save {
      flex: 1;
    }
  }
}
</style>
